"use client";

import React from "react";
import BaseTailoringQuestions, { TailoringQuestion } from "../../shared/BaseTailoringQuestions";

interface OtherFinancialAssetsTailoringQuestionsProps {
  onBack?: () => void;
}

const QUESTIONS: TailoringQuestion[] = [
  {
    id: "ofa-1",
    question: "Are there any government incentives received by the entity during the period?",
    type: "radio",
    options: ["Yes", "No"],
  },
  {
    id: "ofa-2",
    question: "Are there any accounting estimates related to other assets?",
    type: "radio",
    options: ["Yes", "No"],
  },
  {
    id: "ofa-3",
    question:
      "Does the entity have material current and non-current classification of other financial assets in financial statements?",
    type: "radio",
    options: ["Yes", "No"],
  },
  {
    id: "ofa-4",
    question: "Does the entity have material security deposits?",
    type: "radio",
    options: ["Yes", "No"],
    follow_up: {
      condition: "Yes",
      id: "ofa-5",
      question: "Are we planning on sending confirmations for testing the balance?",
      type: "radio",
      options: ["Yes", "No"],
    },
  },
  {
    id: "ofa-6",
    question: "Are there any security deposits pertaining to leases taken by the entity?",
    type: "radio",
    options: ["Yes", "No"],
    condition: {
      questionId: "ofa-4",
      value: "Yes",
    },
  },
];

export default function OtherFinancialAssetsTailoringQuestions({
  onBack,
}: OtherFinancialAssetsTailoringQuestionsProps) {
  return (
    <BaseTailoringQuestions
      areaName="Other Financial Assets"
      title="Other Financial Assets - Tailoring Questions"
      description="Customize the program for Other Financial Assets."
      questions={QUESTIONS}
      onBack={onBack}
    />
  );
}

